import { IndexModel } from "../Support/IndexModel";
export class AccountIndex extends IndexModel {
    endpoint = 'account';
    getData() {
        return super.getData();
    }
}
